import useTypedSelector from '../common/useTypedSelector';
import {SectionEntity} from './types';

export function useGetParentSection(groupId: string): SectionEntity {
  const result = useTypedSelector(state => {
    const groupRelationInfo = state.pagewebLayout.relations.groups[groupId];
    const parentId = groupRelationInfo.parentId;
    return state.pagewebLayout.entities.sections[parentId];
  });
  return result;
}
